import { defineMessages } from 'react-intl';

const messages = defineMessages({
  logIn: {
    id: 'anonymous.log-in',
    defaultMessage: 'Log in',
  },
  logOut: {
    id: 'anonymous.log-out',
    defaultMessage: 'Log out',
  },
  startFree: {
    id: 'anonymous.start-free',
    defaultMessage: 'Create IBM Cloud account',
  },
  account: {
    id: 'authenticated.account',
    defaultMessage: 'Account',
  },
  profile: {
    id: 'authenticated.profile',
    defaultMessage: 'Profile',
  },
  catalog: {
    id: 'authenticated.catalog',
    defaultMessage: 'Catalog',
  },
  billingUsage: {
    id: 'authenticated.billing-usage',
    defaultMessage: 'Billing and usage',
  },
  console: {
    id: 'authenticated.console',
    defaultMessage: 'Console',
  },
});

export default messages;
